module.exports = __webpack_public_path__ + "img/toast1.16ebbac5.png";